import {CommandBase} from "./CommandBase";
import {Reader} from "../entities/Reader";
import {ReaderService} from "../services/ReaderService";
import {ApplicationSettingService} from "../services/ApplicationSettingService";
import {NotificationService} from "../services/NotificationService";
import {CommandManager} from "../libs/CommandManager";
import {IVTag} from "../entities/IVTag";

export class CommandSetPositionGatewayDirective extends CommandBase implements ng.IDirective {
    restrict = 'AEC';
    transclude = false;
    template = require('../../views/cmdsetpositiongateway.html').default;
    scope = {
        map: "=",
        ppm: "=",
        mapArea: "=",
        selectedItems: "=",
        commandEnabled: "=",
    };
    tempGateway: Reader;

    constructor(public modal: angular.ui.bootstrap.IModalService,
                public gatewayService: ReaderService,
                public applicationSettingService: ApplicationSettingService,
                public notificationService: NotificationService,
                commandManager: CommandManager) {
        super(commandManager);
    }

    controller = ['$scope',($scope: any) => {
        $scope.$on('leafletDirectiveMap.mainMap.click', (map:any, evt:any) => {
            //open up dialog and do stuff
            var mapX = evt.leafletEvent.latlng.lng;
            var mapY = evt.leafletEvent.latlng.lat;
            var xMeters = mapX / parseFloat($scope.ppm);
            var yMeters = mapY / parseFloat($scope.ppm);
            if ($scope.commandEnabled) {
                var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
                    animation: true,
                    template: require('../../views/cmdsetpositiongatewaydialog.html').default,
                    controller: 'CmdCenterSetPositionGatewayCtrl',
                    resolve: {
                        vtagX: function () {
                            return xMeters;
                        },
                        vtagY: function () {
                            return yMeters;
                        },
                        vtagZ: function () {
                            return $scope.mapArea.floorLevel;
                        }
                    }
                });
                modalInstance.result.then((memGateway: Reader) => {
                    this.gatewayService.getByName(memGateway.name).then((gateway) => {
                        if (gateway == null) {
                            this.notificationService.notifyError("Got error in saving data");
                        } else {
                            gateway.vTagX = memGateway.vTagX;
                            gateway.vTagY = memGateway.vTagY;
                            gateway.vTagZ = memGateway.vTagZ;
                            gateway.lastSeen = new Date().toUTCString();
                            this.gatewayService.update(gateway).then(() => {
                                this.notificationService.notify("Gateway coordinates have been saved.")
                            })
                            .catch((err: any) => {
                                this.notificationService.notifyError("Got error in saving data:" + err);
                            });
                        }
                    });
                })
            }
        });
    }]

    getItems() {
        return [this.tempGateway];
    }

    getCommandText(tag: IVTag): string {
        return tag.vTagID + ":" + tag.vTagX + ":" + tag.vTagY + ":" + tag.vTagZ;
    }

    getCommandType(): string {
        return "Set Position Gateway";
    }

    static factory(): ng.IDirectiveFactory {
        var directive = (modal: angular.ui.bootstrap.IModalService,
                         commandManager: CommandManager,
                         gatewayService: ReaderService,
                         applicationSettingService: ApplicationSettingService,
                         notificationService: NotificationService) => {
            return new CommandSetPositionGatewayDirective(modal, gatewayService, applicationSettingService, notificationService, commandManager);
        }
        directive.$inject = ['$uibModal', 'CommandManager', 'ReaderService', 'ApplicationSettingService', 'NotificationService'];
        return directive;
    }
}
